import {Modal} from 'react-bootstrap'
import styles from './DeleteRecipientModal.css'
import {cancelDeleteRecipient, onDeleteRecipient} from 'actions/setting/emailNotification'

class DeleteRecipientModal extends React.Component {
  render () {
    let {showDeleteRecipientModal, deletedRecipient} = this.props
    return (<Modal show={showDeleteRecipientModal} onHide={this._onHide} bsClass='margin-top-modal modal'>
      <Modal.Header bsClass={`modal-header ${styles.header}`}>
        <button onClick={this._onCancel}
          type='button'
          className='close'
          data-dismiss='modal'
          aria-label='Close'>
          <span aria-hidden='true'>
            &times;
          </span>
        </button>
        <h4>Delete Recipient</h4>
      </Modal.Header>
      <Modal.Body>
        {deletedRecipient && `Are you sure want to remove email ${deletedRecipient.email}?`}
      </Modal.Body>
      <Modal.Footer>
        <button onClick={this._onCancel} className='btn btn-default'>Cancel</button>
        <button onClick={this._onDelete} className='btn btn-danger'>Delete</button>
      </Modal.Footer>
    </Modal>)
  }

  _onCancel = () => {
    this.props.dispatch(cancelDeleteRecipient())
  }

  _onDelete = () => {
    let {deletedRecipient, emailNotificationForm} = this.props
    this.props.dispatch(onDeleteRecipient(deletedRecipient, emailNotificationForm))
  }
}

DeleteRecipientModal.propTypes = {
  showDeleteRecipientModal: React.PropTypes.bool,
  dispatch: React.PropTypes.func,
  deletedRecipient: React.PropTypes.object
}

export default DeleteRecipientModal



// WEBPACK FOOTER //
// ./app/pages/AccountSetting/EmailNotification/EmailNotificationForm/DeleteRecipientModal/DeleteRecipientModal.js